import { Component, Vue } from "vue-property-decorator";
import {
  matGetApp,
  matChevronLeft,
  matChevronRight,
  matRefresh,
  matDone
} from "@quasar/extras/material-icons";
import { PendingDocument } from "@/models/DownloadDocument/PendingDocument";
import axios, { AxiosRequestConfig } from "axios";
import { sleep } from "@/utils/sleep";
import { DocumentApiData } from "@/models/DownloadDocument/DocumentApiData";
import { bus } from "../main"; 
import busEvents from "@/bus/busEvents";
import { DynamicFile } from "@/models/DownloadDocument/DynamicFile";

@Component
export default class DownloadDocument extends Vue {

  private language = "";
  private brand = "";

  private downloads: PendingDocument[] = [];
  private documentsApiPublicKey!: string;

  private matGetApp = matGetApp;
  private matChevronLeft = matChevronLeft;
  private matChevronRight = matChevronRight;
  private matPending = matRefresh;
  private matDone = matDone;

  private collapsed = false;
  private hidden = true;

  private useGlobalLoader = true;

  public store = this.$store.direct;

// UI effecting function
  private onCollapse() {
    this.collapsed = !this.collapsed;
  }
  private downloadFile(filepath: string) {
    window.open(filepath);
  }
  private setLoader(state: boolean) {
    if(state)
      this.store.dispatch.appStateModule.setLoaderOn()
    else this.store.dispatch.appStateModule.setLoaderOff()
  }

// feature functionality
  public created() {
    this.language = this.store.getters.appStateModule.getLanguage;
    const brand = this.store.getters.appStateModule.getBrand;
    if(brand)
      this.brand = brand;
    bus.$on(busEvents.DOWNLOAD_DYNAMIC_DOCUMENT, this.onAddFileToDownload);
  }
  public async onAddFileToDownload(file: DynamicFile) {
    if (!this.useGlobalLoader) this.hidden = false;
    const existingEntry = this.downloads.find(x => x.id == file.id);
    if (existingEntry) return file.callback(existingEntry.filepath);

    this.getDocument(file);
  }

  public async getDocument(file: DynamicFile) {
    this.setLoader(true);
    this.downloads.push({
      id: file.id,
      name: file.name,
      pending: true
    } as PendingDocument);
    try {
      const documentApiData = await this.sendDocumentCreateReq(file);
        if (documentApiData.PublicApiKey)
        {
          this.documentsApiPublicKey = documentApiData.PublicApiKey;
        }
        if (documentApiData.Url) {
            file.callback(documentApiData.Url);
            this.setLoader(false);
        }
        else  {
            await sleep(1000);
            this.intervallyTryGetDocument(documentApiData.StateUrl ,file.id, documentApiData.DocumentUrl, documentApiData.SessionId, this.BuildQueryParams(file), this.documentsApiPublicKey, (filepath: string) => file.callback(filepath));
        }
    }
    catch(err) {
      console.error(err);
      this.setLoader(false);
    }
  }

  private async sendDocumentCreateReq(file: DynamicFile): Promise<DocumentApiData> {
    const queryParamsApi = this.BuildQueryParams(file);
    const queryParams = {templateName: queryParamsApi.templateName, ...queryParamsApi.tags, withFullInfo: !this.documentsApiPublicKey, requestDate: new Date()};
    const res = await axios.get(
      location.origin + "/api/dxp/document/createDocument",
      { params: queryParams }
    ); 
    return res.data as DocumentApiData;
  }

private async queryForState(apiUrl: string, id: string, requestDate: Date): Promise<any> {
    const config = {
        headers: { "x-api-key": this.documentsApiPublicKey }
    } as AxiosRequestConfig;
    const res = await axios.get(apiUrl + `?id=${id}&requestDate=${requestDate}`, config);
    return res.data.state ?? undefined
}

  private async queryForDocument(apiUrl: string, id: string): Promise<string> {
    const config = {
      headers: { "x-api-key": this.documentsApiPublicKey }
    } as AxiosRequestConfig;
    const res = await  axios.get(apiUrl + `?id=${id}`, config);
    return res.data.url ?? undefined
  }

    private async intervallyTryGetDocument(stateApiUrl: string,
        fileId: string,
        documentApiUrl: string,
        id: string,
        queryParams: any,
        publicApiKey: string,
        callback: (filepath: string) => void) {
        let state = 0;
        let date = new Date();
      do {
        try {
            state = await this.queryForState(stateApiUrl, id, date);
            if (state === 4) {
                const filepath = await this.queryForDocument(documentApiUrl, id);
                this.downloads.forEach(element => {
                  if (element.id !== fileId) return;
                  element.filepath = filepath;
                  element.pending = false;
                  this.setLoader(false);
                  if (this.useGlobalLoader) callback(element.filepath);
            }
            );
          }
          else if(state === 5){
            console.log('break loop due to error');
            this.setLoader(false);
            break;
        }
          date = new Date(date.getTime() + 3000);
          await sleep(3000);
        }
        catch(err) {
          console.error(err)
          console.log('break loop due to error');
          this.setLoader(false);
          break;
        }
      }
      while(state !== 4)
  }

//   helper functions
  private BuildQueryForApi(params: any): string {
    let queryParams = `templatename=${params.templateName}`;
    Object.keys(params.tags).forEach(key => {
      queryParams = queryParams + `&tags[${key}]=${params.tags[key]}`;
    });
    return queryParams;
  }

  private BuildQueryParams(file: DynamicFile): any {
    const keys = Object.keys(file.tags);
    if(!keys.find(k => k == "language")){
      file.tags = {...file.tags, language: this.language}
    }
    if(!keys.find(k => k == "brand")){
      file.tags = {...file.tags, brand: this.brand}
    }
    return {
        templateName: file.templateName,
        tags: file.tags
      };
  }

}
